import { render } from "./AlphaButton.vue?vue&type=template&id=007808a6"
import script from "./AlphaButton.vue?vue&type=script&lang=js"
export * from "./AlphaButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__